import { TBillingContextValue } from '@commenda/types/src/billing/types';
import { createContext, useContext } from 'react';

export const BillingContext = createContext<TBillingContextValue>(null);

export const useBillingContext = () => {
  const context = useContext(BillingContext);
  if (!context) {
    throw new Error(
      'useBillingContext must be used within BillingContextProvider'
    );
  }
  return context;
};
